import { Injectable } from '@angular/core';
import { Router, ActivatedRouteSnapshot, Route } from '@angular/router';
import { Roles } from '@helper/enums/roles.enum';
import { AuthService } from 'AuthService';

@Injectable()
export class AuthGuard {
  constructor(
    private router: Router,
    private authService: AuthService
  ) {}

  canActivate(route: ActivatedRouteSnapshot) {
    if (this.authService.isAuth()) {
      if (this.authService.isExtern()) {
        if (!this.canExtern(route)) {
          return false;
        } else {
          if (this.authService.isSub()) {
            if (!this.canSub(route)) {
              return false;
            } else {
              return true;
            }
          } else {
            return true;
          }
        }
      } else if (this.authService.hasOneRole(this.getNeededRoles(route))) {
        return true;
      } else {
        return false;
      }
    }

    this.router.navigate(['/login']);
    return false;
  }

  private canExtern(route: ActivatedRouteSnapshot | Route): boolean {
    const canExtern = route.data['extern'];
    if (!canExtern) {
      return false;
    }

    return canExtern === true;
  }

  private canSub(route: ActivatedRouteSnapshot | Route): boolean {
    const canSub = route.data['sub'];
    if (!canSub) {
      return false;
    }

    return canSub === true;
  }

  private getNeededRoles(route: ActivatedRouteSnapshot | Route): Roles[] {
    const _roles: Roles[] = [];
    if (!route.data['roles']) {
      return _roles;
    }

    for (let i = 0; i < route.data['roles'].length; i++) {
      const r = route.data['roles'][i] as string;
      const role = Roles[r] as Roles;
      if (role) {
        _roles.push(role);
      } else {
        throw new Error("Konnte '" + r + "' keiner vorhandenen Zugriffsbeschränkung zuordnen!");
      }
    }

    return _roles;
  }
}
